module.exports = __webpack_public_path__ + "img/4722035197_52719245725_聚学u111-01 1@2x.d3ea5ffe.png";